import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Home from "./pages/Home";
import Monitor from "./pages/Monitor";
import Generator from "./pages/Generator";
import ForumLogin from "./pages/ForumLogin";
import AuthCallback from "@/pages/AuthCallback";
import Profile from "@/pages/Profile";
import ThemeToggle from "./components/ThemeToggle";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/monitor" component={Monitor} />
      <Route path="/generator" component={Generator} />
      <Route path="/login" component={ForumLogin} />
      <Route path="/auth/callback" component={AuthCallback} />
      <Route path="/profile" component={Profile} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark" storageKey="domain-price-theme" switchable={true}>
        <LanguageProvider>
          <TooltipProvider>
            <Toaster />
            <ThemeToggle />
            <Router />
          </TooltipProvider>
        </LanguageProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;